import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface OpenIntegrationsRequest {
  projectId?: string;
}

/**
 * BehaviorSubject (not a plain Subject): the settings modal lives on the dashboard
 * shell, which may not be instantiated yet when a route guard fires this request
 * (guards for the whole route tree resolve before parent components mount), so the
 * last value must replay to a late subscriber.
 */
@Injectable({ providedIn: 'root' })
export class SettingsModalTriggerService {
  private readonly request$ = new BehaviorSubject<OpenIntegrationsRequest | null>(null);
  readonly openIntegrationsRequest$ = this.request$.asObservable();

  requestOpenIntegrations(projectId?: string): void {
    this.request$.next({ projectId });
  }

  clearRequest(): void {
    this.request$.next(null);
  }
}
